import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { generateClassName } from '../utils';

export default class extends Component {
  componentDidMount() {
    if (!this.props.getParent) {
      return;
    }
    const parent = this.props.getParent();
    if (parent) {
      const pBox = parent.getBoundingClientRect();
      const me = ReactDOM.findDOMNode(this);
      const meBox = me.getBoundingClientRect();
      let left;
      if (this.props.rightAligned) {
        left = pBox.right - meBox.width;
      } else {
        left = pBox.left;
      }
      me.style.left = left + 'px';
      const height = meBox.height;
      const top =
        pBox.bottom + height > window.innerHeight
          ? pBox.top - height
          : pBox.bottom;
      me.style.top = top + 'px';
    }

    window.addEventListener('mousedown', this.didClickOnWindow);
  }
  componentWillUnmount() {
    window.removeEventListener('mousedown', this.didClickOnWindow);
  }
  didClickOnWindow = e => {
    if (!this.props.getParent) {
      return;
    }
    const el = ReactDOM.findDOMNode(this);
    const cta = this.props.getParent();
    if (!el.contains(e.target) && e.target !== cta && !cta.contains(e.target)) {
      this.props.onClose();
    }
  };
  render() {
    const className = generateClassName('menu', {
      selectable: this.props.selectable,
      rightAligned: this.props.rightAligned
    });
    const children = [];
    const parseChildren = items => {
      items.forEach(child => {
        if (child.type === React.Fragment) {
          parseChildren(React.Children.toArray(child.props.children));
          return;
        }
        children.push(
          React.cloneElement(child, {
            key: children.length,
            onClick: this.props.onClick,
            onHover: this.props.onHover
          })
        );
      });
    };
    parseChildren(React.Children.toArray(this.props.children));
    return <ul className={className}>{children}</ul>;
  }
}



// WEBPACK FOOTER //
// ./src/components/Menu.js